import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';
import { AuthProvider } from './contexts/AuthContext';
import { UserProvider } from './contexts/UserContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import BurgerMenu from './components/BurgerMenu';
import PhotoGuide from './components/pages/PhotoGuide';
import PhotoUpload from './components/pages/PhotoUpload';
import TrainingProgress from './components/pages/TrainingProgress';
import Generate from './components/pages/Generate';
import Account from './components/pages/Account';
import Login from './components/auth/Login';
import Signup from './components/auth/Signup';
import './App.css';

// Create InstaWorthy theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#667eea',
      light: '#764ba2',
      dark: '#5a67d8',
    },
    secondary: {
      main: '#FF8E53',
      light: '#FE6B8B',
      dark: '#f56565',
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 12,
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
      },
    },
    MuiCard: {
      root: {
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      },
    },
  },
});

// Wrapper component for protected routes that includes the burger menu
function ProtectedLayout({ children }) {
  return (
    <>
      <BurgerMenu />
      {children}
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <UserProvider>
          <Router>
            <div className="App">
              <Switch>
                {/* Public Routes */}
                <Route exact path="/" component={Login} />
                <Route path="/signup" component={Signup} />
                
                {/* Protected Routes */}
                <ProtectedRoute exact path="/guide">
                  <ProtectedLayout>
                    <PhotoGuide />
                  </ProtectedLayout>
                </ProtectedRoute>
                
                <ProtectedRoute path="/upload">
                  <ProtectedLayout>
                    <PhotoUpload />
                  </ProtectedLayout>
                </ProtectedRoute>
                
                <ProtectedRoute path="/training">
                  <ProtectedLayout>
                    <TrainingProgress />
                  </ProtectedLayout>
                </ProtectedRoute>
                
                <ProtectedRoute path="/generate">
                  <ProtectedLayout>
                    <Generate />
                  </ProtectedLayout>
                </ProtectedRoute>
                
                <ProtectedRoute path="/gallery">
                  <ProtectedLayout>
                    <div>Gallery Page - Coming Soon!</div>
                  </ProtectedLayout>
                </ProtectedRoute>
                
                <ProtectedRoute path="/account">
                  <ProtectedLayout>
                    <Account />
                  </ProtectedLayout>
                </ProtectedRoute>
                
                {/* Redirect any unmatched routes to home */}
                <Route path="*">
                  <Redirect to="/" />
                </Route>
              </Switch>
            </div>
          </Router>
        </UserProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;